import { useQuery } from '@tanstack/react-query';
import { updateTenantDetails } from "../orgPanelApiCalls";
import { useStore } from "../appStore"

const key = 'organizationTenant';

const useUpdateTenantQuery = () => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    return useQuery({ queryKey: [key], queryFn: () => updateTenantDetails(orgId) })
}

export { useUpdateTenantQuery, key };